import { render, staticRenderFns } from "./WideLayout.vue?vue&type=template&id=664ecaa6&"
import script from "./WideLayout.vue?vue&type=script&lang=js&"
export * from "./WideLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports